module.exports = __webpack_public_path__ + "img/sand-decal-07.f518a364.png";